'use client';

import { UrgencyType } from '@/app/(intakeFormV2)/intake-v2/types';
import { useCallback, useState } from 'react';
import { useIntakeWizardContext } from '../../../contexts/WizardProvider';
import { useWizardNavigation } from '../../../hooks/useWizardNavigation';
import { IntakeRadioGroup } from '../../common/IntakeRadioGroup';
import { IntakeStepWrapper } from '../../common/IntakeStepWrapper';

import './UrgencyStep.scss';

export const UrgencyStep = () => {
  const {
    state: {
      formData: { urgency: value },
    },
    dispatch,
  } = useIntakeWizardContext();

  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();
  const [error, setError] = useState<string | undefined>();

  const urgentcyOptions = [
    {
      value: 'Right away-I have an urgent medical need or concern',
      label: (
        <p className='UrgencyStep__option'>
          Right away—
          <span className='UrgencyStep__highlighter'>
            (Sollis can activate your account today.)
          </span>
        </p>
      ),
    },
    {
      value: 'Soon-I want to be proactive about my future medical needs',
      label: 'Soon—I want to be proactive about my future medical needs',
    },
    {
      value: "Not sure yet-I'm still learning more about Sollis",
      label: "Not sure yet—I'm still learning more about Sollis",
    },
  ];

  const handleChange = useCallback(
    (value: string) => {
      dispatch({
        type: 'SET_FORM_DATA',
        payload: { urgency: value as UrgencyType },
      });

      setError(undefined);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();

      if (!value) {
        setError('Please select an option');

        return;
      }

      goToNextStep();
    },
    [value, goToNextStep]
  );

  return (
    <IntakeStepWrapper
      heading='When do you want to start this membership?'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <IntakeRadioGroup
        name='urgency'
        options={urgentcyOptions}
        value={value}
        onChange={handleChange}
        error={error}
      />
    </IntakeStepWrapper>
  );
};
